<template>
  <div class="date-tabs">

    <button class="tab-btn"
            @click="$emit(common.inputEvent, tabs.hour)"
            :class="{ selected: value === tabs.hour }"
            :disabled="isPending"
    >
      <span class="mobile-hidden">{{ i18n.trd_chart_hour() }}</span>
    </button>

    <button class="tab-btn"
            @click="$emit(common.inputEvent, tabs.day)"
            :class="{ selected: value === tabs.day }"
            :disabled="isPending"
    >
      <span class="mobile-hidden">{{ i18n.trd_chart_day() }}</span>
    </button>

    <button class="tab-btn"
            @click="$emit(common.inputEvent, tabs.month)"
            :class="{ selected: value === tabs.month }"
            :disabled="isPending"
    >
      <span class="mobile-hidden">{{ i18n.trd_chart_month() }}</span>
    </button>

    <button class="tab-btn"
            @click="$emit(common.inputEvent, tabs.year)"
            :class="{ selected: value === tabs.year }"
            :disabled="isPending"
    >
      <span class="mobile-hidden">{{ i18n.trd_chart_year() }}</span>
    </button>

  </div>
</template>

<script>
  import { commonEvents } from '@js/events/common_events'
  import { i18n } from '@js/i18n'

  export default {
    name: 'date-tabs',
    props: ['value', 'isPending'],

    data () {
      return {
        common: {
          inputEvent: commonEvents.inputEvent
        },
        tabs: {
          hour: 'hour',
          day: 'day',
          week: 'week',
          month: 'month',
          year: 'year',
          all: 'all'
        },
        i18n
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~scss/variables";
  @import "~scss/mixins";

  .date-tabs {
    display: flex;
    justify-content: flex-start;
    max-height: 52px;

    @include respond-to(medium) {
      margin-bottom: 16px;
    }
  }

  .tab-btn {
    max-height: 40px;
    margin: 0 5px;
    padding: 8px;
    color: $col-text-secondary;
    background-color: transparent;
    border: none;
    cursor: pointer;


    &.selected {
      color: $col-md-primary;
      border-bottom: 1px solid $col-md-primary;
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/sales/sale_details/components/chart/ChartWidget.DateTabs.vue